import React from 'react';
import { useKnowledgeCommonFlagHook } from '@atlassian/jira-servicedesk-knowledge-common/src/controllers/hooks/use-knowledge-common-flag-hook/index.tsx';
import { KbFlags as KnowledgeCommonFlags } from '@atlassian/jira-servicedesk-knowledge-common/src/ui/kb-flags/index.tsx';
import messages from './messages';

export const DraftArticleSuccessFlags = () => {
	const [kbCommonflags, resetDraftArticleData] = useKnowledgeCommonFlagHook(messages);
	const onDismissed = () => {
		resetDraftArticleData(true);
	};
	// @ts-expect-error - TS2322 - Type '() => void' is not assignable to type '(id: string | number) => Promise<undefined> | undefined'.
	return <KnowledgeCommonFlags flags={kbCommonflags} onDismissed={onDismissed} />;
};
